import React from 'react';
import './MainContent.scss';

interface MainContentProps {
  children: React.ReactNode;
}

const MainContent: React.FC<MainContentProps> = ({ children }) => {
  return (
    <div className="main-content">
      <div className="main-content__container">
        {children}

        {/* Переносимо футер всередину контейнера */}
        <footer className="main-content__footer">
          <div className="main-content__footer-line"></div>
          <span className="main-content__footer-text">
            Need help? Contact our{' '}
            <a href="mailto:support@propsavvy.ca" className="main-content__footer-link">
              support
            </a>
            !
          </span>
        </footer>
      </div>
    </div>
  );
};

export default MainContent;